import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import Sidebar from "../components/Sidebar";
import axios from "axios";

export default function EditBlog() {
  const navigate = useNavigate();
  const { id } = useParams();

  const [form, setForm] = useState({
    title: "",
    image: "",
    link: "",
  });

  /* 🔹 FETCH BLOG DATA (PREFILL) */
  useEffect(() => {
    axios
      .get(`https://api.livestockify.com/api/admin/blogs/${id}`)
      .then((res) => {
        setForm({
          title: res.data.blogTitle || "",
          image: res.data.imageURL || "",
          link: res.data.blogLink || "",
        });
      })
      .catch((err) => {
        console.error("Failed to load blog", err);
      });
  }, [id]);

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  /* 🔹 UPDATE BLOG */
  const handleUpdate = async () => {
    try {
      const payload = {
        blogTitle: form.title,
        imageURL: form.image,
        blogLink: form.link,
      };

      await axios.put(
        `https://api.livestockify.com/api/admin/blogs/${id}`,
        payload,
      );

      navigate("/blog");
    } catch (error) {
      console.error("Failed to update blog", error);
      alert("Update failed");
    }
  };

  return (
    <div className="flex min-h-screen bg-gray-100">
      {/* Sidebar */}
      <Sidebar />

      {/* Main */}
      <div className="flex-1 bg-white rounded-l-2xl p-6">
        <h2 className="text-green-700 font-semibold mb-8 underline">
          Edit Blog
        </h2>

        <div className="flex justify-center">
          <div className="w-full max-w-2xl mx-auto space-y-6 ">
            {/* Blog Title */}
            <div className="flex flex-col md:flex-row md:items-center gap-2 md:gap-6">
              <label className="md:w-28 text-sm font-medium text-center md:text-left">Blog Title</label>
              <input
                name="title"
                value={form.title}
                onChange={handleChange}
                placeholder="Enter Blog Title"
                className="border rounded-md px-3 py-2 w-full"
              />
            </div>

            {/* Image URL */}
            <div className="flex flex-col md:flex-row md:items-center gap-2 md:gap-6">
              <label className="md:w-28 text-sm font-medium text-center md:text-left">Image URL</label>
              <input
                name="image"
                value={form.image}
                onChange={handleChange}
                placeholder="Enter Image URL"
                className="border rounded-md px-3 py-2 w-full"
              />
            </div>

            {/* Blog Link */}
            <div className="flex flex-col md:flex-row md:items-center gap-2 md:gap-6">
              <label className="md:w-28 text-sm font-medium text-center md:text-left">Blog Link</label>
              <input
                name="link"
                value={form.link}
                onChange={handleChange}
                placeholder="Enter Blog Link"
                className="border rounded-md px-3 py-2 w-full"
              />
            </div>

            {/* Buttons */}
            <div className="flex flex-col sm:flex-row justify-end gap-3 pt-6">
              <button
                onClick={() => navigate("/blog")}
                className="border px-6 py-2 rounded-md"
              >
                Cancel
              </button>

              <button
                onClick={handleUpdate}
                className="bg-green-500 text-white px-6 py-2 rounded-md"
              >
                Update
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
